import { Link } from "react-router-dom";
import { isRouterUrl } from "../tokens";

// Petits éléments partagés par les sections du moteur "couture_v1".

// Un lien interne passe par le routeur (y compris « /page#ancre », que
// useHashScroll fait défiler une fois la page chargée) ; tout le reste —
// ancre pure, http(s), tel:, mailto: — reste un <a>. Défini au niveau du
// module : une fonction recréée à chaque rendu remonterait ses enfants.
export const SmartLink = ({ url = "", className, children, onClick, ...rest }) =>
  isRouterUrl(url) ? (
    <Link to={url} className={className} onClick={onClick} {...rest}>{children}</Link>
  ) : (
    <a href={url || "#"} className={className} onClick={onClick} {...rest}>{children}</a>
  );

// Séparateur trait — losange — trait de l'affiche des horaires : deux
// filets `clamp(60px,14vw,150px)` et un carré de 5px tourné de 45°.
export const DiamondRule = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3.5 ${className}`} aria-hidden="true">
    <span className="block h-px bg-ink/[0.22]" style={{ width: "clamp(60px,14vw,150px)" }} />
    <span className="block w-[5px] h-[5px] bg-ink rotate-45" />
    <span className="block h-px bg-ink/[0.22]" style={{ width: "clamp(60px,14vw,150px)" }} />
  </div>
);

// Photo de fond d'une bande : l'image si elle est téléversée, sinon rien
// (le fond sombre de la bande reste seul, comme un emplacement en attente).
export const CoverImage = ({ src, alt = "", opacity = 1, className = "" }) =>
  src ? (
    <img
      src={src}
      alt={alt}
      className={`absolute inset-0 w-full h-full object-cover ${className}`}
      style={{ opacity }}
      loading="lazy"
    />
  ) : null;
